<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
import Swal from "sweetalert2";
import {cloneDeep} from 'lodash';
export default {
    props: {
        data: Object,
        fromPR: Boolean
    },
    components: {
        LoadingTemplate,
        RawData
    },
    data() {
        return {
            movePrItem: null 
        }
    },
    computed: {
        filteredRfqItems(){
            let data = this.data.rfqItems;
            if(this.data.reAward){
                data = this.data.rfqItems.filter(x => x.isReAward);
            }
            if(this.data.searchItem && this.data.searchItem != ""){
                data = data.filter(x => x.itemName.toLowerCase().includes(this.data.searchItem.toLowerCase()))
            }
            return data;
        },
        filteredPrItems(){
            let data = this.data.prItems;
            if(this.data.searchItem && this.data.searchItem != ""){
                data = data.filter(x => x.itemName.toLowerCase().includes(this.data.searchItem.toLowerCase()))
            }
            return data;
        }
    },
    methods: {
        selectForRecanvas(){
            this.data.forReAward = false;
            this.data.forRecanvas = true;
            this.data.selectItems = true;
        },
        showReAward(){
            return this.data.rfqItems.filter(x => x.isReAward).length > 0;
        },
        selectAllItems(){
            this.data.rfqItems.map(x => x.selected = this.data.selectAll)
        },
        cancelSelectionOfItems(){
            this.data.selectItems = false;
            this.data.rfqItems.map(x => x.selected = false);
            this.data.selectAll = false;
        },
        countItemSelected(type){
            if(type === 'reaward'){
                return this.data.rfqItems.filter(x => x.selected && x.isReAward).length;
            }
            return this.data.rfqItems.filter(x => x.selected).length;
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        async removeItem(row, type) {
            var yIndex = this.data.rfqItems.findIndex((x) => x.id === row.id);
            var realData = [row]; 
            // var realData = row.grouped ? row.children : [row]; 
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    let done = 0;
                    for await(const child of realData){
                        await this.$store
                            .dispatch("rfqitem/DeleteRfqItem", child.id)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                done++
                            })
                            .catch((err) => {});
                    }
                    if(done == realData.length){
                        this.data.rfqItems.splice(yIndex, 1)
                        this.showToast("Successfully removed!", "success");
                    }else{
                        this.showToast("Something went wrong!", "error");
                    }
                }
            });
        },
        async changeUnit(rfqItem){
            this.$emit('changeUnit', rfqItem);
        },
        updatePRItem(prItem){
            this.$emit('updatePRItem', prItem)
        },
        viewLogs(prItem){
            this.$emit('viewLogs', prItem)
        },
        handleMouseDown(e, item) {
            if(item.withChild){
                return;
            }
            this.movePrItem = item;
            e.target.style.cursor = 'grabbing';
            e.target.parentNode.parentNode.setAttribute('draggable', 'true');
        },
        handleMouseUp(e, item) {
            if(item.withChild){
                return;
            }
            e.target.style.cursor = 'grab';
            e.target.parentNode.parentNode.setAttribute('draggable', 'false');
        },
        onDropZone(e, item, rfq) { 
            if(this.movePrItem.rfqId != item.rfqId) return;
            let fromIndex = rfq.rfqItems.findIndex(x => x.id == this.movePrItem.id);
            let toIndex = rfq.rfqItems.findIndex(x => x.id == item.id);
            if(fromIndex < -1) return;
            if(toIndex < -1) return;
            const element = rfq.rfqItems.splice(fromIndex, 1)[0];
            rfq.rfqItems.splice(toIndex, 0, element);
        },
        ifSortMoved(rfq){
            return JSON.stringify(rfq.rfqItems) != JSON.stringify(rfq.copyItems);
        },
        updateItemsSort(rfq){
            rfq.updateSorting = !rfq.updateSorting;
            if(rfq.updateSorting){
                rfq.copyItems = cloneDeep(rfq.rfqItems);
            }else{
                rfq.rfqItems = cloneDeep(rfq.copyItems);
            }
        },
        saveSort(rfq){
            let data = [];
            rfq.rfqItems.map((item, index) => {
                data.push({
                    id: item.id,
                    sort: index + 1
                })
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You want to update the sorting?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, update!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfqitem/UpdateSorting", data)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            rfq.copyItems = cloneDeep(rfq.rfqItems);
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        }
    }
}
</script>
<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <div v-if="!data.selectItems">
                <button type="button" class="btn btn-sm btn-outline-success" @click="selectForRecanvas" v-if="!showReAward"><i class="bx bx-list-check"></i> Select Items for Recanvass</button>
            </div>
            <div class="d-flex align-items-center justify-content-between" v-if="data.selectItems && !fromPR">
                <div class="form-check form-checkbox-outline form-check-success">
                    <input
                        type="checkbox"
                        :id="`select-all-items-${data.id}`"
                        checked="checked"
                        class="form-check-input"
                        v-model="data.selectAll"
                        @change="selectAllItems"
                    />
                    <label :for="`select-all-items-${data.id}`" class="form-check-label">
                        Select all
                    </label>
                </div>
                <span class="mx-2"></span>
                <button type="button" class="btn btn-sm btn-outline-warning" @click="cancelSelectionOfItems"><i class="bx bx-x"></i> Cancel</button>
            </div>
            <div v-else class="d-flex">
                <button type="button" class="btn btn-success btn-sm me-1 no-wrap" v-if="ifSortMoved(data)" @click="saveSort(data)">
                    <i class="bx bx-save"></i> Save Sort
                </button>
                <input type="text" class="form-control form-control-sm" placeholder="Search item..." v-model="data.searchItem">
            </div>
            <template v-if="!fromPR">
                <div v-if="countItemSelected('recanvas') != 0 && data.forRecanvas" class="d-flex align-items-center">
                    With {{ countItemSelected('recanvas') }} selected: Recanvass? <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="recanvasItem(x)"><i class="bx bx-check"></i> Go</button>
                </div>
                <div v-if="countItemSelected('reaward') != 0 && data.forReAward" class="d-flex align-items-center">
                    With {{ countItemSelected('reaward') }} selected: Reaward? <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="reAwardRfqItems(x)"><i class="bx bx-check"></i> Go</button>
                </div>
            </template>
        </div>
        <div class="d-flex justify-content-between mb-3">
            <p class="mb-0" :class="{'text-success': data.itemMsgType === 'success', 'text-danger': data.itemMsgType === 'danger'}">
                {{ data.itemMessage }}
            </p>
        </div>
        <table
            class="
                table
                table-bordered
            "
        >
            <thead>
                <tr class="custom-border-2">
                    <th>Item Name
                        <div><small>Item Description</small></div>
                    </th>
                    <th style="width: 120px;">Unit</th>
                    <th style="width: 70px;">Qty</th>
                    <th style="width: 150px;">Unit Cost</th>
                    <th style="width: 150px;">Total</th>
                    <th style="width: 50px;"></th>
                </tr>
            </thead>
            <tbody>
                <template v-if="!fromPR">
                    <template v-if="!data.rfqItemLoading && data.rfqItems.length > 0">
                        <tr
                            v-for="(z, zIndex) in filteredRfqItems"
                            :key="`poffer-${z.id}`"
                            @drop="onDropZone($event, z, data)"
                            @dragenter.prevent
                            @dragover.prevent
                        >
                            
                            <td class="position-relative">
                                <RawData 
                                    :data="z"
                                    placement="left"
                                    :keyId="`rfq-item-${data.id}${z.id}-${zIndex}`"
                                    v-if="$store.state.decrypt.isAdmin()" 
                                />
                                <div class="d-flex">
                                    <div style="min-width:20px;height:20px;" class="bg-success bg-gradient text-white d-flex align-items-center justify-content-center me-1">{{zIndex + 1}}</div>
                                    <div 
                                        v-if="!data.selectItems || (data.selectItems && data.forReAward && !z.isReAward)" 
                                        :class="{'grab-cursor': !data.withChild}" 
                                        @mousedown="handleMouseDown($event, z)" 
                                        @mouseup="handleMouseUp($event, z)"
                                    >
                                        <span v-if="z.bidItemName">{{ z.bidItemName }}</span>
                                        <span v-else class="font-size-10 text-yellow">{{ z.itemName }} (Not yet modified)</span>
                                    </div>
                                    <div v-if="(data.selectItems && data.forRecanvas) || (data.selectItems && data.forReAward && z.isReAward)">
                                        <div
                                            class="
                                                form-check
                                                form-checkbox-outline
                                                form-check-success
                                            "
                                        >
                                            <input
                                                type="checkbox"
                                                :id="`select-rfq-items-${z.id}`"
                                                class="form-check-input"
                                                v-model="z.selected"
                                                @change="selectRfqItem(x)"
                                            />
                                            <label
                                                :for="`select-rfq-items-${z.id}`"
                                                class="form-check-label"
                                            >
                                                {{ z.itemName}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <small>{{ `${z.bidItemName ? z.bidDescription : z.description}` }}</small>
                                </div>
                                <div>
                                    <!-- <a href="javascript:void(0);" class="hover-underline btn btn-primary btn-sm" @click="returnPRItems(z.prItem)">Return to Delivery Unit for Editing</a>  -->
                                    <a href="javascript:void(0);" class="hover-underline btn btn-success btn-sm me-1" @click="updatePRItem(z)"><i class="bx bx-edit"></i> Update Item</a>
                                    <a href="javascript:void(0);" class="hover-underline btn btn-secondary btn-sm" @click="viewLogs(z)"><i class="bx bx-receipt"></i> View Logs</a>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    {{ z.unit.shortName }}
                                    <a href="javascript:void(0);" class="text-green ms-1" @click="changeUnit(z)"><i class="bx bx-edit"></i></a>
                                </div>
                            </td>
                            <td>
                                <div>{{ z.quantity}}</div>
                                <div v-if="z.withChild"><a href="javascript:void(0);" @click="viewConsolidatedItems(z.prItemId, x)">Child</a></div>
                            </td>
                            <td> {{formatCurrency(z.unitCost)}}</td>
                            <td>{{formatCurrency(z.total)}}</td>
                            <td class="text-center">
                                <a
                                    href="javascript:void(0);"
                                    title="Remove Item"
                                    @click="removeItem(z, 'submitted')"
                                    v-if="!z.withChild"
                                >
                                    <i class="bx bx-trash text-danger font-size-18"></i>
                                </a>
                            </td>
                        </tr>
                    </template>
                    <tr v-if="data.rfqItemLoading">
                        <td colspan="5">
                            <LoadingTemplate />
                        </td>
                    </tr>
                    <tr
                        v-if="!data.rfqItemLoading && data.rfqItems.length == 0"
                    >
                        <td
                            colspan="6"
                            class="
                                text-center
                            "
                        >
                            <i
                                >No
                                items
                                found</i
                            >
                        </td>
                    </tr>
                    <tr
                        class="border border-dashed"
                        v-if="!data.rfqItemLoading && data.rfqItems.length > 0"
                    >
                        <td colspan="4" class="text-right py-2 px-2">
                            Total Bid Amount:
                        </td>
                        <td colspan="2" class="py-2">
                            {{ formatCurrency(getTotalPerPR(data.rfqItems)) }}
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <template v-if="!data.prItemLoading && data.prItems.length > 0">
                        <tr
                            v-for="(z, zIndex) in filteredPrItems"
                            :key="`poffer-${z.id}`"
                            @drop="onDropZone($event, z, x)"
                            @dragenter.prevent
                            @dragover.prevent
                        >
                            
                            <td class="position-relative">
                                <RawData 
                                    :data="z"
                                    placement="left"
                                    :keyId="`rfq-item-${data.id}${z.id}-${zIndex}`"
                                    v-if="$store.state.decrypt.isAdmin()" 
                                />
                                <div class="d-flex">
                                    <div style="min-width:20px;height:20px;" class="bg-success bg-gradient text-white d-flex align-items-center justify-content-center me-1">{{zIndex + 1}}</div>
                                    <div 
                                        v-if="!data.selectItems || (data.selectItems && data.forReAward && !z.isReAward)" 
                                        :class="{'grab-cursor': !data.withChild}" 
                                        @mousedown="handleMouseDown($event, z)" 
                                        @mouseup="handleMouseUp($event, z)"
                                    >
                                        <span class="font-size-15">{{ z.itemName }}</span>
                                    </div>
                                </div>
                                <div>
                                    <small>{{ z.description }}</small>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    {{ z.unit }}
                                    <!-- <a href="javascript:void(0);" class="text-green ms-1" @click="changeUnit(z)"><i class="bx bx-edit"></i></a> -->
                                </div>
                            </td>
                            <td>
                                <div>{{ z.quantity}}</div>
                                <div v-if="z.withChild"><a href="javascript:void(0);" @click="viewConsolidatedItems(z.id, x)">Child</a></div>
                            </td>
                            <td> {{formatCurrency(z.unitCost)}}</td>
                            <td>{{formatCurrency(z.total)}}</td>
                            <td class="text-center">
                                <!-- <a
                                    href="javascript:void(0);"
                                    title="Remove Item"
                                    @click="removeItem(z, 'submitted')"
                                    v-if="!z.withChild"
                                >
                                    <i class="bx bx-trash text-danger font-size-18"></i>
                                </a> -->
                            </td>
                        </tr>
                    </template>
                    <tr v-if="data.prItemLoading">
                        <td colspan="5">
                            <LoadingTemplate />
                        </td>
                    </tr>
                    <tr
                        v-if="!data.prItemLoading && data.prItems.length == 0"
                    >
                        <td
                            colspan="6"
                            class="
                                text-center
                            "
                        >
                            <i
                                >No
                                items
                                found</i
                            >
                        </td>
                    </tr>
                    <tr
                        class="border border-dashed"
                        v-if="!data.prItemLoading && data.prItems.length > 0"
                    >
                        <td colspan="4" class="text-right py-2 px-2">
                            Total Bid Amount:
                        </td>
                        <td colspan="2" class="py-2">
                            {{ formatCurrency(getTotalPerPR(data.prItems)) }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>